import { createFileRoute, useRouter, useSearch } from '@tanstack/react-router';
import { MfaEnrolOrChallenge } from '@/lib/auth/MfaEnrolOrChallenge';
import { resolveSafeNext } from '@/lib/nav/safeNext';

export const Route = createFileRoute('/sign-in/mfa')({
  component: AdminMfa,
  validateSearch: (search: Record<string, unknown>) => ({
    next: typeof search.next === 'string' ? search.next : undefined,
  }),
});

function AdminMfa() {
  const router = useRouter();
  const { next } = useSearch({ from: '/sign-in/mfa' });

  return (
    <section className="mx-auto max-w-sm rounded-card border border-border bg-surface p-xl shadow-card">
      <h1 className="text-h2 font-extrabold text-ink">Two-factor authentication required</h1>
      <p className="mt-xs text-body text-ink-2">Every admin session needs AAL2 (spec §3).</p>
      <div className="mt-lg">
        <MfaEnrolOrChallenge
          onSuccess={() => {
            // See the matching business route's comment: router.history.push
            // takes a plain string so a dynamic `next` (which AAL2-gated
            // admin route redirected here) doesn't need an unsafe cast.
            // resolveSafeNext rejects anything but a same-origin relative
            // path (see safeNext.ts).
            router.history.push(resolveSafeNext(next));
          }}
        />
      </div>
    </section>
  );
}
